import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a40415e5560c38c5cd6c4a733d27ec3e2b from "./generated-ce79f3d1-8f59-4b75-b843-3da580d48e91.json";

import a43ee028d5a8ccee4ff01d078dda0f3e7b from "./generated-80760452-5187-488f-a25f-58953b4c4a7b.json";

import a1302f67f33da0957463f8509f2ccd150b from "./generated-37748e4b-e8b6-46e9-b8a9-4fb9e76a372f.json";

import a71944c250ba860733207ebbcd1174607b from "./generated-4a63f4f5-a9ad-42c3-b3fd-672438e0573b.json";

import aedd4152188eaf7acbf4df9165e6cd859b from "./generated-5f20703b-f2a2-4dca-8a6f-74965953e66e.json";

import a0194f20395d1bc8fdeb3d9b92cf188ceb from "./generated-f143a1da-059f-4068-8429-559c324085f6.json";

import a3164833560096aeadcf239ec5ed04126b from "./generated-3e1c84ae-9d6f-4f3b-9bd5-a976798e2a4d.json";

import ab97ee381b92d6637d95293746b378dbab from "./generated-47c3bd73-6791-4af9-a7b8-9127141853b6.json";

import ac5627f8527b80a3cbc96099503d89947b from "./generated-2b4395ce-fd39-4cd7-9285-cd78e641a32d.json";

import a09033840fd506de304094db3cf56cf09b from "./generated-bf8822d2-5c2c-4bdd-94c0-551a6041d4ca.json";

import a1909d6ee8ba1233b00c0bda198e38475b from "./generated-ce99a849-3d37-4e06-9216-37bdc93adc54.json";

import a2b0699fa61a79595ba70522c594a11e3b from "./generated-921d725c-f72e-4727-bee4-a8c79919664f.json";

import aeaf65dfe1ec2baa907b2005d72138198b from "./generated-5758873e-3a1a-40c4-9794-74c1ccf99038.json";

import a128ecb028647ebd024bde99d85b03358b from "./generated-6b3bf649-30b0-483c-98a3-fd996d2726e7.json";

import a7cd4040548df6efab31becc97890d4c7b from "./generated-35eb4dff-9dd5-4a29-9598-1d592d223206.json";

import add7e02d164de5ca42a7a32afd247b9f8b from "./generated-a5cd990f-46ce-4f55-b3b7-dce45138c18a.json";

import ad7bc2b7227e494126986c19a3a99fee6b from "./generated-0468d917-ccd2-4ec3-b93f-8f41b12a9e65.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a40415e5560c38c5cd6c4a733d27ec3e2b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a43ee028d5a8ccee4ff01d078dda0f3e7b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a1302f67f33da0957463f8509f2ccd150b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a71944c250ba860733207ebbcd1174607b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(aedd4152188eaf7acbf4df9165e6cd859b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a0194f20395d1bc8fdeb3d9b92cf188ceb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a3164833560096aeadcf239ec5ed04126b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(ab97ee381b92d6637d95293746b378dbab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(ac5627f8527b80a3cbc96099503d89947b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a09033840fd506de304094db3cf56cf09b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a1909d6ee8ba1233b00c0bda198e38475b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a2b0699fa61a79595ba70522c594a11e3b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(ac5627f8527b80a3cbc96099503d89947b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(aeaf65dfe1ec2baa907b2005d72138198b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a128ecb028647ebd024bde99d85b03358b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(ac5627f8527b80a3cbc96099503d89947b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a7cd4040548df6efab31becc97890d4c7b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(add7e02d164de5ca42a7a32afd247b9f8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(ad7bc2b7227e494126986c19a3a99fee6b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a7cd4040548df6efab31becc97890d4c7b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */